import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Box } from '@mui/system';
import type { FC } from 'react';

import type { ProductPerPlant } from './useLocationProductsGrouping';

type LocationToCopyProps = {
  plant: ProductPerPlant;
  selected: boolean;
  onSelectionChange: (locationId: string, isChecked: boolean) => void;
};

export const LocationToCopy: FC<LocationToCopyProps> = ({ plant, selected, onSelectionChange }) => {
  const allMatch = plant.notMatch.length === 0;
  const textColor = allMatch ? '#0B815A' : '#FF7B01';

  return (
    <Box display='flex' alignItems='center'>
      <FormControlLabel
        sx={{ flexGrow: '1' }}
        control={
          <Checkbox
            checked={selected}
            onChange={(_, checked) => onSelectionChange(plant.plantId, checked)}
          />
        }
        label={plant.plantName}
      />
      <Box sx={{ color: textColor, display: 'flex' }}>
        {allMatch ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
        <Typography sx={{ color: textColor, marginLeft: '0.25rem' }}>
          {plant.match.length}/{plant.match.length + plant.notMatch.length}
        </Typography>
      </Box>
    </Box>
  );
};
